<template>
  <div id="contenedor-agregar-partida-contable">
    <v-form v-model="formularioValido" ref="registrarCatalogoPartidaContable">
      <v-card>
        <v-card-title class="secondary--text">
          Agregar nueva Partida Contable
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <custom-text-field
            label="Número de la Partida Contable"
            v-model="catalogoPartidaContable.numero"
            :rules="[mixReglas.requerido]"
            required
          >
          </custom-text-field>
          <custom-text-field
            label="Descripción"
            v-model="catalogoPartidaContable.descripcion"
            :rules="[mixReglas.requerido]"
            required
          >
          </custom-text-field>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="guardar"
            :disabled="!formularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';
import CustomTextField from '@/components/inputs/TextField.vue';
import mixCatalogoPartidasContables from './mixCatalogoPartidasContables';

export default {
  name: 'AgregarCatalogoPartidaContable',
  mixins: [mixCatalogoPartidasContables],
  components: {
    CustomButton,
    CustomTextField,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      catalogoPartidaContable: {
        numero: '',
        descripcion: '',
      },
    };
  },
  methods: {
    async guardar() {
      await this.mixAgregarCatalogoPartidaContable().then(() => {
        this.cerrar();
      });
    },
    clearForm() {
      this.$refs.registrarCatalogoPartidaContable.reset();
      this.catalogoPartidaContable = {
        numero: '',
        descripcion: '',
      };
    },
    cerrar() {
      this.clearForm();
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss">

</style>
